var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOilChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.404 28.476-18.98 7.952a.5.5 0 0 1-.457-.034L4.832 25.864a.498.498 0 0 1-.18-.662l7.873-14.917a.504.504 0 0 1 .686-.205l13.306 7.183a.51.51 0 0 1 .242.301l2.127 7.14a.495.495 0 0 0 .38.352l12.042 2.461a.502.502 0 0 1 .096.959zM28.58 33.841 6.966 20.816M19.958 13.721l2.712-4.884",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.576 12.282 17.472 6.326",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "em",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98 16.999 4.59 11.9a2.44 2.44 0 0 1-.135-3.01L5.8 7.026a2.436 2.436 0 0 1 3.658-.36l3.306 3.156M46 40.823a4.14 4.14 0 1 1-8.279 0c0-2.286 4.14-6.982 4.14-6.982S46 38.537 46 40.823z",
    stroke: "currentColor",
    strokeWidth: "0.03em",
    strokeMiterlimit: "0.2em"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilChange);
export default __webpack_public_path__ + "static/media/oil-change.3f91187a6d6c7a9b7ba2841667201cc1.svg";
export { ForwardRef as ReactComponent };